import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { operatorCallsApi } from '@/lib/api/operator-calls.api';

const ELIGIBILITY_KEY = ['operator-calls', 'eligibility'];

export const useCallEligibility = (
  contactId: string | undefined,
  configurationId: string | undefined,
) =>
  useQuery({
    queryKey: [...ELIGIBILITY_KEY, contactId, configurationId],
    queryFn: () => operatorCallsApi.getEligibility(contactId!, configurationId!),
    enabled: !!contactId && !!configurationId,
    staleTime: 30000,
  });

export const useInitiateCall = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      contactId,
      configurationId,
      channel,
      overridePermission,
    }: {
      contactId: string;
      configurationId: string;
      channel: 'pstn' | 'whatsapp';
      overridePermission?: boolean;
    }) => operatorCallsApi.initiate(contactId, configurationId, channel, overridePermission),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ELIGIBILITY_KEY });
    },
  });
};

export const useEndCall = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (callSid: string) => operatorCallsApi.end(callSid),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ELIGIBILITY_KEY });
    },
  });
};

export const useRequestWhatsAppPermission = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ contactId, configurationId }: { contactId: string; configurationId: string }) =>
      operatorCallsApi.requestWhatsAppPermission(contactId, configurationId),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ELIGIBILITY_KEY });
    },
  });
};

export const useCheckWhatsAppPermission = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ contactId, configurationId }: { contactId: string; configurationId: string }) =>
      operatorCallsApi.checkWhatsAppPermission(contactId, configurationId),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ELIGIBILITY_KEY });
    },
  });
};
